(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-wishlist"]) return;
  try {
    
  (() => {
    const WISHLIST_KEY = 'carybell_wishlist';

    const container = document.querySelector('[data-wishlist-container]');

    const emptyState = document.querySelector('[data-wishlist-empty]');

    if (!container || !emptyState) return;

    function getWishlist() {
      try {
        const value = localStorage.getItem(WISHLIST_KEY);

        if (!value) {
          return [];
        }

        const parsed = JSON.parse(value);

        return Array.isArray(parsed) ? parsed : [];
      } catch (error) {
        console.warn('[Carybell] Unable to read wishlist.', error);

        return [];
      }
    }

    function saveWishlist(items) {
      try {
        localStorage.setItem(WISHLIST_KEY, JSON.stringify(items));
      } catch (error) {
        console.warn('[Carybell] Unable to save wishlist.', error);
      }
    }

    function escapeHtml(value) {
      const div = document.createElement('div');

      div.textContent = value || '';

      return div.innerHTML;
    }

    function formatPrice(price) {
      const currency = container.dataset.currency || 'INR';

      try {
        return new Intl.NumberFormat('en-IN', {
          style: 'currency',
          currency,
          maximumFractionDigits: 0,
        }).format(price / 100);
      } catch {
        return `${currency} ${(price / 100).toFixed(0)}`;
      }
    }

    async function getProduct(handle) {
      const response = await fetch(`/products/${encodeURIComponent(handle)}.js`);

      if (!response.ok) {
        throw new Error(`Unable to load product: ${handle}`);
      }

      return response.json();
    }

    function renderEmpty() {
      container.innerHTML = '';

      emptyState.hidden = false;
    }

    function renderLoading() {
      emptyState.hidden = true;

      container.innerHTML = `
      <div class="wishlist-loading">
        Loading your wishlist...
      </div>
    `;
    }

    function createCard(product) {
      const card = document.createElement('article');

      card.className = 'wishlist-card';

      const image = product.featured_image || product.images?.[0] || '';

      const price = product.price;

      card.innerHTML = `
      <div class="wishlist-card__media">

        <a
          href="${product.url}"
          aria-label="${escapeHtml(product.title)}"
        >
          ${
            image
              ? `
                <img
                  class="wishlist-card__image"
                  src="${image}"
                  alt="${escapeHtml(product.title)}"
                  loading="lazy"
                  width="800"
                  height="1067"
                >
              `
              : ''
          }
        </a>

        <button
          type="button"
          class="wishlist-card__remove"
          data-wishlist-remove
          data-product-id="${String(product.id)}"
          aria-label="Remove ${escapeHtml(product.title)} from wishlist"
        >
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="1.8"
            stroke-linecap="round"
            aria-hidden="true"
          >
            <path d="M6 6l12 12"></path>
            <path d="M18 6L6 18"></path>
          </svg>
        </button>

      </div>

      <div class="wishlist-card__info">

        <h2 class="wishlist-card__title">
          <a href="${product.url}">
            ${escapeHtml(product.title)}
          </a>
        </h2>

        <div class="wishlist-card__price">
            ${
              product.compare_at_price && product.compare_at_price > product.price
                ? `
                    <span class="wishlist-card__price-current">
                    ${formatPrice(product.price)}
                    </span>

                    <span class="wishlist-card__price-compare">
                    ${formatPrice(product.compare_at_price)}
                    </span>
                `
                : `
                    <span class="wishlist-card__price-current">
                    ${formatPrice(product.price)}
                    </span>
                `
            }
        </div>

        <a
          href="${product.url}"
          class="wishlist-card__action"
        >
          View Product
        </a>

      </div>
    `;

      return card;
    }

    async function renderWishlist() {
      const wishlist = getWishlist();

      if (!wishlist.length) {
        renderEmpty();
        return;
      }

      renderLoading();

      const results = await Promise.allSettled(
        wishlist.filter((item) => item.handle).map((item) => getProduct(item.handle))
      );

      container.innerHTML = '';

      const validProducts = [];

      results.forEach((result) => {
        if (result.status === 'fulfilled') {
          validProducts.push(result.value);
        }
      });

      if (!validProducts.length) {
        renderEmpty();
        return;
      }

      emptyState.hidden = true;

      validProducts.forEach((product) => {
        container.appendChild(createCard(product));
      });

      bindRemoveButtons();
    }

    function bindRemoveButtons() {
      container.querySelectorAll('[data-wishlist-remove]').forEach((button) => {
        button.addEventListener('click', () => {
          const productId = String(button.dataset.productId || '');

          const wishlist = getWishlist();

          const updated = wishlist.filter((item) => String(item.id) !== productId);

          saveWishlist(updated);

          const card = button.closest('.wishlist-card');

          if (card) {
            card.remove();
          }

          if (!updated.length) {
            renderEmpty();
          }

          document.dispatchEvent(
            new CustomEvent('carybell:wishlist-change', {
              detail: {
                wishlist: updated,
              },
            })
          );
        });
      });
    }

    document.addEventListener('carybell:wishlist-change', renderWishlist);

    window.addEventListener('storage', (event) => {
      if (event.key === WISHLIST_KEY) {
        renderWishlist();
      }
    });

    renderWishlist();
  })();

  } catch(e) { console.error(e); }
})();
})();
